export default {"src":"/_next/static/media/road3.08927391.svg","height":206,"width":206,"blurWidth":0,"blurHeight":0};